// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";
import blogImg4 from "../images/blog/img-1.jpg";
import blogImg5 from "../images/blog/img-2.jpg";
import blogImg6 from "../images/blog/img-3.jpg";
import blogImg7 from "../images/blog/img-2.jpg";
import blogImg8 from "../images/blog/img-4.jpg";
import blogImg9 from "../images/blog/img-5.jpg";
import blogImg10 from "../images/blog/img-6.jpg";
import blogImg11 from "../images/blog/img-7.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";
import blogSingleImg4 from "../images/blog-details/4.jpg";
import blogSingleImg5 from "../images/blog-details/5.jpg";
import blogSingleImg6 from "../images/blog-details/6.jpg";
import blogSingleImg7 from "../images/blog-details/7.jpg";


import recent1 from "../images/recent-posts/img-1.jpg";
import recent2 from "../images/recent-posts/img-2.jpg";
import recent3 from "../images/recent-posts/img-3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Ramadan 2024: Community Iftar Programme',
        title2: 'Join Us for Nightly Iftars This Ramadan',
        subtitle: 'PCIC Committee',
        slug: 'ramadan-2024-community-iftar',
        screens: blogImg1,
        link: 'READ MORE',
        description: 'Join us for nightly community iftars during Ramadan. Share meals, prayers, and blessings with your fellow Muslims in Point Cook.',
        author: 'PCIC Committee',
        create_at: '15-11-2024',
        blogSingleImg: blogSingleImg1,
        recent: recent1,
        comment: '12',
        day: '15',
        month: 'NOV',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Mosque Building Fund: Progress Update',
        title2: 'We Have Reached 35% of Our Goal',
        subtitle: 'PCIC Committee',
        slug: 'mosque-building-fund-update',
        screens: blogImg2,
        link: 'READ MORE',
        description: 'Alhamdulillah, we have raised $175,000 towards our $500,000 goal. Learn about our progress and how you can contribute.',
        author: 'Dr. Zakir Hussain Syed',
        create_at: '10-11-2024',
        blogSingleImg: blogSingleImg2,
        recent: recent2,
        comment: '28',
        day: '10',
        month: 'NOV',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'Islamic Education Classes for Children',
        title2: 'Weekend Quran and Islamic Studies',
        subtitle: 'PCIC Committee',
        slug: 'islamic-education-classes',
        screens: blogImg3,
        link: 'READ MORE',
        description: 'Enrol your children in our weekend Islamic education programme. Learn Quran recitation, Arabic, and Islamic values.',
        author: 'Adnan Saeed',
        create_at: '05-11-2024',
        blogSingleImg: blogSingleImg3,
        recent: recent3,
        comment: '18',
        day: '05',
        month: 'NOV',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '4',
        title: 'Youth Camp 2024: Building Tomorrow\'s Leaders',
        title2: 'Register Now for Summer Islamic Camp',
        subtitle: 'PCIC Committee',
        slug: 'youth-camp-2024',
        screens: blogImg4,
        link: 'READ MORE',
        description: 'Join our annual youth camp focused on Islamic knowledge, leadership skills, and outdoor activities for ages 10-17.',
        author: 'Mahmodul Hasan',
        create_at: '28-10-2024',
        blogSingleImg: blogSingleImg4,
        recent: recent3,
        comment: '22',
        day: '28',
        month: 'OCT',
        blClass: 'format-standard-image',
        animation: '1200',
    },

    {
        id: '5',
        title: 'Sisters Circle: New Programme Launch',
        title2: 'Weekly Halaqah for Muslim Women',
        subtitle: 'PCIC Committee',
        slug: 'sisters-circle-launch',
        screens: blogImg5,
        link: 'READ MORE',
        description: 'Announcing our new Sisters Circle programme featuring weekly Islamic studies, Quran tafseer, and community support.',
        author: 'PCIC Committee',
        create_at: '20-10-2024',
        blogSingleImg: blogSingleImg5,
        recent: recent3,
        comment: '15',
        day: '20',
        month: 'OCT',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '6',
        title: 'Eid ul-Adha Celebrations Recap',
        title2: 'A Beautiful Day of Worship and Fellowship',
        subtitle: 'PCIC Committee',
        slug: 'eid-ul-adha-recap',
        screens: blogImg6,
        link: 'READ MORE',
        description: 'Thank you to everyone who joined us for Eid prayers. See photos and highlights from our blessed celebration.',
        author: 'Dr. Zakir Hussain Syed',
        create_at: '18-06-2024',
        blogSingleImg: blogSingleImg6,
        recent: recent3,
        comment: '42',
        day: '18',
        month: 'JUN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '7',
        title: 'Volunteer Appreciation: Thank You',
        title2: 'Celebrating Our Dedicated Community Members',
        subtitle: 'PCIC Committee',
        slug: 'volunteer-appreciation',
        screens: blogImg7,
        link: 'READ MORE',
        description: 'Jazakum Allahu Khayran to all our volunteers who make PCIC\'s programmes possible through their selfless service.',
        author: 'Adnan Saeed',
        create_at: '10-06-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '30',
        day: '10',
        month: 'JUN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '8',
        title: 'New Tajweed Classes Starting Soon',
        title2: 'Perfect Your Quran Recitation',
        subtitle: 'PCIC Committee',
        slug: 'tajweed-classes-starting',
        screens: blogImg8,
        link: 'READ MORE',
        description: 'Learn the art of beautiful Quran recitation with our qualified teachers. Classes for beginners and intermediate students.',
        author: 'Mahmodul Hasan',
        create_at: '01-06-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '19',
        day: '01',
        month: 'JUN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '9',
        title: 'Community Clean-Up Day Success',
        title2: 'Working Together for Point Cook',
        subtitle: 'PCIC Committee',
        slug: 'community-clean-up-day',
        screens: blogImg9,
        link: 'READ MORE',
        description: 'Our community service initiative brought together 50 volunteers to beautify local parks and public spaces.',
        author: 'PCIC Committee',
        create_at: '15-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '25',
        day: '15',
        month: 'MAY',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '10',
        title: 'Friday Khutbah Topics This Month',
        title2: 'Spiritual Growth Series Continues',
        subtitle: 'PCIC Committee',
        slug: 'friday-khutbah-topics',
        screens: blogImg10,
        link: 'READ MORE',
        description: 'Join us for our continuing series on strengthening faith in modern times. New topics every Friday after Jumu\'ah.',
        author: 'Dr. Zakir Hussain Syed',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '16',
        day: '01',
        month: 'MAY',
        blClass: 'format-standard-image',
        animation: '1200',
    },

    {
        id: '11',
        title: 'Interfaith Dialogue Event',
        title2: 'Building Bridges in Our Community',
        subtitle: 'PCIC Committee',
        slug: 'interfaith-dialogue-event',
        screens: blogImg11,
        link: 'READ MORE',
        description: 'PCIC hosted local faith leaders for a dialogue on shared values and community harmony in Point Cook.',
        author: 'Adnan Saeed',
        create_at: '20-04-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '38',
        day: '20',
        month: 'APR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 


];
export default blogs;



